/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react";
import {
  Alert,
  Button,
  Form,
  ButtonGroup,
  InputGroup,
  Card,
  Container,
  Dropdown,
  Modal,
  Spinner,
} from "@themesberg/react-bootstrap";
import { useState } from "react";
import { useCallback } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useEffect } from "react";
import { toast } from "react-hot-toast";
import { apiURL, deleteApi, fetchApi, postApi } from "../../../redux/api";
import CustomTable from "../../../components/CustomTable";
import SearchInput from "../../../components/SearchInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { fetchUserData } from '';
import {
  faCheck,
  faEye,
  faPrint,
  faArchive,
  faUndo,
} from "@fortawesome/free-solid-svg-icons";
import { Routes } from "../../../routes";
import { formatNumber } from "../../../redux/utils";
import { SearchContext } from "../../HomePage";
import { useSelector } from "react-redux";
import { Col, Row, Nav, Tab } from "react-bootstrap";
import moment from "moment-timezone";
import CustomButton from "../../../components/CustomButton";

function ApprovePaymentRequest({ match, type = null }) {
  const user = useSelector((state) => state.auth.user);
  const history = useNavigate();
  const location = useLocation();
  const isPending = location.pathname.includes("payapp");
  const { searchTerm, setSearchTerm } = useContext(SearchContext);
  const imageExtensions = [".jpg", ".jpeg", ".png", ".gif"];
  const [filterText, setFilterText] = useState("");
  const batch_no = useParams().batch_no;
  const [budgetUtilization, setBudgetUtilization] = useState([]);
  const [modal, setModal] = useState(false);
  const [filter, setFilter] = useState(type || "All");
  const [attachmentModalIsOpen, setAttachmentModalIsOpen] = useState(false);
  const [selectedApproval, setApprovalNo] = useState("");
  const [returndApproval, retApprovalNo] = useState("");

  const [approvalImageInfo, setApprovalImageInfo] = useState([]);
  const [item, setItem] = useState({});
  const [_delete, setDelete] = useState(false);
  const [loading, setLoading] = useState(false);

  const [dateFrom, setDateFrom] = useState(moment().subtract(1, 'month').format('YYYY-MM-DD'));
  const [dateTo, setDateTo] = useState(moment().format('YYYY-MM-DD'));

  const toggleDelete = (item) => {
    setItem(item);
    setDelete(!_delete);
  };
  const [showRemark1, setShowRemark1] = useState(false);
  const [showRemark, setShowRemark] = useState(false);
  const [remark, setRemark] = useState("");
  const [approvalLoading, setApprovalLoading] = useState(false);
  const [returnlLoading, setReturnLoading] = useState(false);
  const [returnlMessage, setReturnMessage] = useState(null);
  const [approvalMessage, setApprovalMessage] = useState(null);
  const [userData, setUserData] = useState(null);
  const [selectedReleases, setSelectedReleases] = useState([])
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false)
  const [preparingSchedule, setPreparingSchedule] = useState(false)
  const [archiveModalOpen, setArchiveModalOpen] = useState(false)
  const [itemToArchive, setItemToArchive] = useState(null)
  const [archiving, setArchiving] = useState(false)
  const [restoreModalOpen, setRestoreModalOpen] = useState(false)
  const [itemToRestore, setItemToRestore] = useState(null)
  const [restoring, setRestoring] = useState(false)
  const [activeTab, setActiveTab] = useState("pending")
  const [archivedData, setArchivedData] = useState([])
  const [archivedLoading, setArchivedLoading] = useState(false)

  const toggleRemark = () => setShowRemark((p) => !p);
  const toggleRemark1 = () => setShowRemark1((p) => !p);

  const attachmentModalToggle = () => {
    setAttachmentModalIsOpen((p) => !p);
  };

  const getApprovalCollection = useCallback(() => {
    setLoading(true);
    postApi(`post_approval_collection`, {
      form: {
        query_type: "pending_payment",
        approval_status: "Review",
        // approval_status: "Payment Raised"
        // mda_name: user?.mda_name, mda_code: user?.mda_code || "",
      },
    })
      .then((data) => {
        if (data.result) {
          const arr = data.result.map((item) => ({ ...item, isOpen: false }));
          setBudgetUtilization(arr);
        }
      })
      .catch((err) => {
        console.error("Error fetching approval collection:", err);
      })
      .finally(() => setLoading(false));
  }, []);

  const getArchivedCollection = useCallback(() => {
    setArchivedLoading(true);
    postApi(`post_approval_collection`, {
      form: {
        query_type: "archived_payment",
      },
    })
      .then((data) => {
        if (data.result) {
          const arr = data.result.map((item) => ({ ...item, isOpen: false }));
          setArchivedData(arr);
        }
      })
      .catch((err) => {
        console.error("Error fetching archived collection:", err);
      })
      .finally(() => setArchivedLoading(false));
  }, []);

  useEffect(() => {
    if (activeTab === "pending") {
      getApprovalCollection();
    } else {
      getArchivedCollection();
    }
  }, [activeTab, getApprovalCollection, getArchivedCollection]);

  //   const handleFilter = () => {
  //     const filteredList = budgetUtilization.filter((item) => {
  //       const dateFromCondition = dateFrom ? new Date(item.collection_date) >= new Date(dateFrom) : true;
  //       const dateToCondition = dateTo ? new Date(item.collection_date) <= new Date(dateTo) : true;
  //       return dateFromCondition && dateToCondition;
  //     });
  //     return filteredList;
  //   };

  // useEffect(() => {
  //   handleFilter();
  // }, [dateFrom, dateTo]);

  //   const filteredList = handleFilter();

  //   let list = [];
  //   filteredList.forEach((item) => {
  //     if (
  //       item.approval_no.indexOf(filterText) === -1 &&
  //       item.approval_no.toString().indexOf(filterText.toLowerCase()) === -1
  //     )
  //       return;
  //     else list.push(item);
  //   });

  const updateReturnApproval = (approval_no, status) => {
    setReturnLoading(true);
    postApi("return-approval", {
      remarks: remark,
      status,
      approval_no,
      userId: user.username,
    })
      .then((resp) => {
        setReturnLoading(false);
        if (resp && resp.success) {
          setReturnMessage("Return Successfully");
          setTimeout(() => {
            toggleRemark();
            getApprovalCollection();
          }, 1000);
        }
      })
      .catch((err) => {
        setReturnLoading(false);
        toast.error("An error occured, please try again later");
        console.log(err);
      });
  };

  const updateApproval = (approval_no, status) => {
    setApprovalLoading(true);
    postApi("update-approval", {
      query_type: 'update_ag_status',
      remarks: remark,
      status: "AG Approved",
      approval_no,
      userId: user.username,
      mda_code: user?.mda_code,
    })
      .then((resp) => {
        setApprovalLoading(false);
        if (resp && resp.success) {
          setApprovalMessage(
            status === "Return Processed"
              ? "Returned Releases Successfully"
              : "Approved Successfully"
          );
          setTimeout(() => {
            toggleRemark();
            getApprovalCollection();
          }, 1000);
        }
      })
      .catch((err) => {
        setApprovalLoading(false);
        toast.error("An error occured, please try again later");
        console.log(err);
      });
  };

  //   const finalList = [];
  //   list.forEach((item) => {
  //     if (item.approval_no.toString().indexOf(searchTerm) === -1) return;
  //     finalList.push(item);
  //   });

  //   const onCheck = (item) => {
  //     let newList = []
  //     let itemFound = selectedReleases.find(s => s.id === item.id)
  //     if(itemFound) {
  //         newList = selectedReleases.filter(s => s.id !== item.id)
  //     } else {
  //         newList = [...selectedReleases,item]
  //     }
  //     setSelectedReleases(newList)
  //   }

  //   const onCheckAll = () => {
  //     if(selectedReleases.length) {
  //         setSelectedReleases([])
  //     } else {
  //         setSelectedReleases(finalList)
  //     }
  //   }

  const fields = () => {
    const baseFields = [
      {
        title: "Batch Code",
        custom: true,
        component: (item) => (
          <div className="text-center">{(item.payment_batch_id)}</div>
        ),
      },
      {
        title: "No. of Approvals",
        custom: true,
        component: (item) => (
          <div className="text-center">{(item.approvals)}</div>
        ),
      },
      {
        title: "Amount",
        custom: true,
        component: (item) => (
          <div className="text-end">{formatNumber(item.amount)}</div>
        ),
      },
    ];

    const actionField = {
      title: "Action",
      custom: true,
      component: item => (
        <div className="text-center">
          <ButtonGroup size="sm">
            <Button
              variant="outline-primary"
              onClick={() =>
                history(
                  `${Routes.paymentRequest.viewPaymentRequestDetailFinal}/${item.payment_batch_id}?from=archived`
                )
              }
            >
              <FontAwesomeIcon icon={faEye} className="me-1" />
              View
            </Button>
            {activeTab === "pending" ? (
              <Button
                variant="outline-secondary"
                onClick={() => handleArchive(item)}
              >
                <FontAwesomeIcon icon={faArchive} className="me-1" />
                Archive
              </Button>
            ) : (
              <Button
                variant="outline-success"
                onClick={() => handleRestore(item)}
              >
                <FontAwesomeIcon icon={faUndo} className="me-1" />
                Restore
              </Button>
            )}
          </ButtonGroup>
        </div>
      )
    };

    return [...baseFields, actionField];
  };

  const modalFields = [
    {
      title: "Approval No",
      value: "approval_no",
    },
    {
      title: "Release Date",
      value: "approval_date",
    },
    {
      title: "MDA Name",
      value: "mda_name",
    },

    {
      title: "Amount",
      custom: true,
      component: (item) => (
        <div className="text-end">{formatNumber(item.amount)}</div>
      ),
    },
  ];

  const handleDelete = () => {
    setLoading(true);
    deleteApi(`delete-approve-collection`, item)
      .then((res) => {
        toast.success("Deleted Successfully");
        setLoading(false);
        getApprovalCollection();
        toggleDelete({});
      })
      .catch((err) => {
        toast.error(`error occured ${JSON.stringify(err)}`);
        setLoading(false);
      });
  };
  // const ApprovalCollectionIndex = () => {
  //   const { searchTerm, setSearchTerm } = useContext(SearchContext);
  //   // ... rest of the code
  // };

  useEffect(() => {
    return () => {
      setSearchTerm("");
    };
  }, [setSearchTerm]);


  const totalReleases = selectedReleases.reduce((a, b) => a + parseFloat(b.amount), 0)

  const handleArchive = (item) => {
    setItemToArchive(item);
    setArchiveModalOpen(true);
  };

  const confirmArchive = async () => {
    if (!itemToArchive) return;

    setArchiving(true);
    try {
      await postApi('archive_payment_request', {
        payment_batch_id: itemToArchive.payment_batch_id,
        userId: user.username,
        query_type: 'approval_achieve'
      });

      toast.success(`Payment request ${itemToArchive.payment_batch_id} archived successfully`);
      setArchiveModalOpen(false);
      setItemToArchive(null);
      getApprovalCollection(); // Refresh the list after archiving
    } catch (err) {
      toast.error('Failed to archive payment request');
      console.error(err);
    } finally {
      setArchiving(false);
    }
  };

  const cancelArchive = () => {
    setArchiveModalOpen(false);
    setItemToArchive(null);
  };

  const handleRestore = (item) => {
    setItemToRestore(item);
    setRestoreModalOpen(true);
  };

  const confirmRestore = async () => {
    if (!itemToRestore) return;

    setRestoring(true);
    try {
      await postApi('archive_payment_request', {
        payment_batch_id: itemToRestore.payment_batch_id,
        userId: user.username,
        query_type: 'restore_archive'
      });

      toast.success(`Payment request ${itemToRestore.payment_batch_id} restored successfully`);
      setRestoreModalOpen(false);
      setItemToRestore(null);
      getArchivedCollection();
    } catch (err) {
      toast.error('Failed to restore payment request');
      console.error(err);
    } finally {
      setRestoring(false);
    }
  };

  const cancelRestore = () => {
    setRestoreModalOpen(false);
    setItemToRestore(null);
  };

  const prepareSchedule = async () => {
    setPreparingSchedule(true)
    const paymentResp = await fetchApi('number-generator?query_type=select&description=payment')

    // console.log(paymentResp, 'paymentResp')
    if (paymentResp.success && paymentResp.results && paymentResp.results.length) {
      const scheduleId = paymentResp.results[0].next_code;
      console.log(scheduleId, 'scheduleId');

      for (let item of selectedReleases) {
        await postApi("update-approval", {
          query_type: 'update_payment_request',
          remarks: scheduleId,
          status: "Payment Request Reviewed",
          approval_no: item.approval_no,
          userId: user.username,
          mda_name: user?.mda_name, mda_code: user?.mda_code || "",
        })
      }

      await postApi('number-generator', {
        query_type: 'update',
        description: 'cb_schedule',
        code: scheduleId
      })
    }

    setTimeout(() => {
      setPreparingSchedule()
      setScheduleModalOpen(false)
      getApprovalCollection()
    }, 1000);
  }

  return (
    <>
      {/* {JSON.stringify(approval_no)}  */}
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        {/* <Button
          onClick={() => history(Routes.approval.newApproval)}
          className="me-2 bg-success"
        >
          Add Approval
        </Button> */}

        <h4>
          {/* <FontAwesomeIcon icon={faListUl} className="me-2" />  */}
          Approve Payment Request
        </h4>

        {/* {JSON.stringify(searchTerm)} */}
        {/* <div className="btn-toolbar mb-2 mb-md-0">
          <h5>Total Amount Selected: {totalReleases.toLocaleString()}</h5>
        </div> */}
      </div>

      <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
        <Nav variant="tabs" className="mb-3">
          <Nav.Item className="w-50">
            <Nav.Link className="font-weight-bold" eventKey="pending" >Pending</Nav.Link>
          </Nav.Item>
          <Nav.Item className="w-50">
            <Nav.Link className="font-weight-bold" eventKey="archived">Archived</Nav.Link>
          </Nav.Item>
        </Nav>
      </Tab.Container>

      {/* <SearchInput
        placeholder="Search For Releases"
        value={searchTerm}
        onChange={({ target: { value } }) => setSearchTerm(value)}
      /> */}

      <Row>
        <Col md={6} style={{
          marginTop: 28
        }}>
          <SearchInput
            placeholder="Search For All Schedule"
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
          />
        </Col>
        <Col md={6}>
          <Row style={{
            marginBottom: 10
          }}>
            <Col md={6}>
              <Form.Group id="date_from">
                <Form.Label>Date From</Form.Label>
                <Form.Control
                  type="date"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group id="date_to">
                <Form.Label>Date to</Form.Label>
                <Form.Control
                  type="date"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
        </Col>
      </Row>

      <Card border="light" className="table-wrapper table-responsive shadow-sm">
        <Card.Body className="p-0">
          {(activeTab === "pending" ? loading : archivedLoading) ? (
            <div className="d-flex justify-content-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div style={{ height: "60vh", overflow: "scroll" }}>
              <CustomTable
                fields={fields()}
                data={activeTab === "pending" ? budgetUtilization : archivedData}
              />
            </div>
          )}
          {/* {JSON.stringify(finalList)} */}
        </Card.Body>

        {/* <Modal size="xl" show={scheduleModalOpen} onHide={() => setScheduleModalOpen(p=>!p)}>
            <Modal.Header>Preview Schedule</Modal.Header>
            <Modal.Body>
            <CustomTable
                fields={modalFields}
                data={selectedReleases}
              />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={prepareSchedule}><FontAwesomeIcon icon={faCheck} /> Continue</Button>
            </Modal.Footer>
        </Modal> */}

        {/* {budgetUtilization.length ? <center>
            <CustomButton loading={preparingSchedule} onClick={() => setScheduleModalOpen(true)}>Raise Payment Request</CustomButton>
        </center> : null} */}
      </Card>

      {/* Archive Confirmation Modal */}
      <Modal show={archiveModalOpen} onHide={cancelArchive} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Archive</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="warning">
            <Alert.Heading>Are you sure you want to archive this payment request?</Alert.Heading>
            <hr />
            <p className="mb-0">
              <strong>Batch Code:</strong> {itemToArchive?.payment_batch_id}
            </p>
            <p className="mb-0">
              <strong>Number of Approvals:</strong> {itemToArchive?.approvals}
            </p>
            <p className="mb-0">
              <strong>Amount:</strong> ₦{formatNumber(itemToArchive?.amount)}
            </p>
          </Alert>
          <p className="text-muted mt-3">
            This action will archive the payment request. You can restore it later if needed.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cancelArchive} disabled={archiving}>
            Cancel
          </Button>
          <Button variant="warning" onClick={confirmArchive} disabled={archiving}>
            {archiving ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Archiving...
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faArchive} className="me-1" />
                Archive
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Restore Confirmation Modal */}
      <Modal show={restoreModalOpen} onHide={cancelRestore} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Restore</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="info">
            <Alert.Heading>Are you sure you want to restore this payment request?</Alert.Heading>
            <hr />
            <p className="mb-0">
              <strong>Batch Code:</strong> {itemToRestore?.payment_batch_id}
            </p>
            <p className="mb-0">
              <strong>Number of Approvals:</strong> {itemToRestore?.approvals}
            </p>
            <p className="mb-0">
              <strong>Amount:</strong> ₦{formatNumber(itemToRestore?.amount)}
            </p>
          </Alert>
          <p className="text-muted mt-3">
            This action will restore the payment request to the pending list.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cancelRestore} disabled={restoring}>
            Cancel
          </Button>
          <Button variant="success" onClick={confirmRestore} disabled={restoring}>
            {restoring ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Restoring...
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faUndo} className="me-1" />
                Restore
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ApprovePaymentRequest;

